import type { HyperlinkEntry } from "@/shared/types/hyperlink.types";

export const HYPERLINK_FIELDS = ["virtualTour"] as const;

export const HYPERLINK_CUSTOM_FIELD_LABELS = ["website"] as const;

export const isHyperlinkField = (fieldKey: string): boolean =>
  (HYPERLINK_FIELDS as readonly string[]).includes(fieldKey);

export const isHyperlinkCustomField = (label: string): boolean =>
  (HYPERLINK_CUSTOM_FIELD_LABELS as readonly string[]).includes(
    label.toLowerCase().trim(),
  );

export const parseHyperlinkField = (raw: string): HyperlinkEntry[] => {
  if (!raw || raw === "—") return [];
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed as HyperlinkEntry[];
  } catch {
    // Fallback for legacy plain-url values.
  }
  return [{ url: raw }];
};

export const serializeHyperlinkField = (entries: HyperlinkEntry[]): string => {
  const valid = entries.filter((entry) => entry.url.trim() !== "");
  if (valid.length === 0) return "";
  return JSON.stringify(valid);
};

export const isValidUrl = (value: string): boolean => {
  const trimmed = value.trim();
  if (!trimmed) return false;

  try {
    const protocolMatch = trimmed.match(/^([a-zA-Z][a-zA-Z0-9+.-]*):\/\//);

    if (protocolMatch) {
      const protocol = protocolMatch[1].toLowerCase();
      if (protocol !== "http" && protocol !== "https") {
        return false;
      }
      new URL(trimmed);
      return true;
    }

    if (!trimmed.includes(".")) {
      return false;
    }

    if (!/^[a-zA-Z0-9.-]+$/.test(trimmed)) {
      return false;
    }

    new URL(`https://${trimmed}`);
    return true;
  } catch {
    return false;
  }
};
